/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StudyNewsDetail } from './fc-study-news-detail.model';


/**
 * Fc study news preview component is used in study-news-ui and study-news-admin-ui.
 */
@Component({
    selector: 'fc-study-news-preview',
    templateUrl: './fc-study-news-preview.component.html',
    styleUrls: ['./fc-study-news-preview.component.scss']
})
export class FcStudyNewsPreviewComponent {
    /**
     * Article model.
     */
    @Input()
    private _articleDetail: StudyNewsDetail;

    /**
     * Input of article.
     *
     * @returns StudyNewsDetail.
     */
    get articleDetail() {
        return this._articleDetail;
    };

    /**
     * Input Setter _items.
     */
    @Input() set articleDetail(value: StudyNewsDetail) {
        this._articleDetail = value;
        this.safeBodyHtml = this.sanitizer.bypassSecurityTrustHtml(this.articleDetail.mainBodyHtml);
    };
    
    /**
     * SafeHtml for innerHTML body details, this will allow display HTML inside a div.
     */
    private safeBodyHtml: any;
    
    /**
     * Component constructor.
     * 
     * @param sanitizer DomSanitizer.
     */
    constructor(private sanitizer: DomSanitizer) {
    }
    
    /**
     * Getter function for body text.
     * 
     * @returns Any SafeBodyHtml.
     */
    get safeBodyText(): any {
        return this.safeBodyHtml;
    }
}
